import React, { Fragment } from 'react';
import style from './LoadingIndicator.module.scss'
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import { SystemState } from '../../../store/system/types';
import { Col, Spin } from 'antd';
import { Bounce } from "react-awesome-reveal";
import green from '../../images/Layout/Green.png';
import wise from '../../images/Layout/Wise.png';

interface LoadingIndicatorProps {
    system: SystemState
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = (props: LoadingIndicatorProps) => {
    return props.system.showLoading ? (
        <div className={style["loading-indicator"]}>
            <div className={style["center-container"]}>
                <Col>
                <div className={style["bounce-container"]}>
                    <Bounce>
                        <img src={green} alt="Green" />
                    </Bounce>
                </div>
                </Col>
                <div className={style["bounce-container"]}>
                    <Bounce>
                        <img src={wise} alt="Wise" />
                    </Bounce>
                </div>
            </div>
        </div>
    )
    :
    (<Fragment></Fragment>);
};

const mapStateToProps = (state: AppState) => ({
    system: state.system
});

export default connect(mapStateToProps)(LoadingIndicator);
